export default __webpack_public_path__ + "static/media/Margarita.7ed4d319.jpeg";